module.exports = __webpack_public_path__ + "img/presscoins-variation.ca59a01b.png";